/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AdminGetRolesResult } from '../models/admin-get-roles-result';
import { AdminGetUsersResult } from '../models/admin-get-users-result';
import { AdminLoginAsCommand } from '../models/admin-login-as-command';
import { AdminLoginAsResult } from '../models/admin-login-as-result';
import { AdminUpsertRolesCommand } from '../models/admin-upsert-roles-command';
import { AdminUpsertRolesResult } from '../models/admin-upsert-roles-result';
import { PlansUpsertPlanCommand } from '../models/plans-upsert-plan-command';
import { PlansUpsertPlanResult } from '../models/plans-upsert-plan-result';
import { SubscriptionsGetSubscriptionEventsResult } from '../models/subscriptions-get-subscription-events-result';
import { SubscriptionsGetSubscriptionsResult } from '../models/subscriptions-get-subscriptions-result';

@Injectable({
  providedIn: 'root',
})
export class AdminService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getUsers
   */
  static readonly GetUsersPath = '/api/Admin/GetUsers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUsers()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsers$Response(params?: {
    context?: HttpContext
  }
): Observable<StrictHttpResponse<AdminGetUsersResult>> {

    const rb = new RequestBuilder(this.rootUrl, AdminService.GetUsersPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AdminGetUsersResult>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getUsers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsers(params?: {
    context?: HttpContext
  }
): Observable<AdminGetUsersResult> {

    return this.getUsers$Response(params).pipe(
      map((r: StrictHttpResponse<AdminGetUsersResult>) => r.body as AdminGetUsersResult)
    );
  }

  /**
   * Path part for operation getRoles
   */
  static readonly GetRolesPath = '/api/Admin/GetRoles';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRoles()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRoles$Response(params?: {
    context?: HttpContext
  }
): Observable<StrictHttpResponse<AdminGetRolesResult>> {

    const rb = new RequestBuilder(this.rootUrl, AdminService.GetRolesPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AdminGetRolesResult>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getRoles$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRoles(params?: {
    context?: HttpContext
  }
): Observable<AdminGetRolesResult> {

    return this.getRoles$Response(params).pipe(
      map((r: StrictHttpResponse<AdminGetRolesResult>) => r.body as AdminGetRolesResult)
    );
  }

  /**
   * Path part for operation loginAs
   */
  static readonly LoginAsPath = '/api/Admin/LoginAs';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loginAs()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loginAs$Response(params?: {
    context?: HttpContext
    body?: AdminLoginAsCommand
  }
): Observable<StrictHttpResponse<AdminLoginAsResult>> {

    const rb = new RequestBuilder(this.rootUrl, AdminService.LoginAsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AdminLoginAsResult>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loginAs$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loginAs(params?: {
    context?: HttpContext
    body?: AdminLoginAsCommand
  }
): Observable<AdminLoginAsResult> {

    return this.loginAs$Response(params).pipe(
      map((r: StrictHttpResponse<AdminLoginAsResult>) => r.body as AdminLoginAsResult)
    );
  }

  /**
   * Path part for operation upsertRoles
   */
  static readonly UpsertRolesPath = '/api/Admin/UpsertRoles';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `upsertRoles()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  upsertRoles$Response(params?: {
    context?: HttpContext
    body?: AdminUpsertRolesCommand
  }
): Observable<StrictHttpResponse<AdminUpsertRolesResult>> {

    const rb = new RequestBuilder(this.rootUrl, AdminService.UpsertRolesPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AdminUpsertRolesResult>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `upsertRoles$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  upsertRoles(params?: {
    context?: HttpContext
    body?: AdminUpsertRolesCommand
  }
): Observable<AdminUpsertRolesResult> {

    return this.upsertRoles$Response(params).pipe(
      map((r: StrictHttpResponse<AdminUpsertRolesResult>) => r.body as AdminUpsertRolesResult)
    );
  }

  /**
   * Path part for operation upsertPlan
   */
  static readonly UpsertPlanPath = '/api/Admin/UpsertPlan';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `upsertPlan()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  upsertPlan$Response(params?: {
    context?: HttpContext
    body?: PlansUpsertPlanCommand
  }
): Observable<StrictHttpResponse<PlansUpsertPlanResult>> {

    const rb = new RequestBuilder(this.rootUrl, AdminService.UpsertPlanPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PlansUpsertPlanResult>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `upsertPlan$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  upsertPlan(params?: {
    context?: HttpContext
    body?: PlansUpsertPlanCommand
  }
): Observable<PlansUpsertPlanResult> {

    return this.upsertPlan$Response(params).pipe(
      map((r: StrictHttpResponse<PlansUpsertPlanResult>) => r.body as PlansUpsertPlanResult)
    );
  }

  /**
   * Path part for operation getSubscriptions
   */
  static readonly GetSubscriptionsPath = '/api/Admin/GetSubscriptions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSubscriptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubscriptions$Response(params?: {
    context?: HttpContext
  }
): Observable<StrictHttpResponse<SubscriptionsGetSubscriptionsResult>> {

    const rb = new RequestBuilder(this.rootUrl, AdminService.GetSubscriptionsPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SubscriptionsGetSubscriptionsResult>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getSubscriptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubscriptions(params?: {
    context?: HttpContext
  }
): Observable<SubscriptionsGetSubscriptionsResult> {

    return this.getSubscriptions$Response(params).pipe(
      map((r: StrictHttpResponse<SubscriptionsGetSubscriptionsResult>) => r.body as SubscriptionsGetSubscriptionsResult)
    );
  }

  /**
   * Path part for operation getSubscriptionEvents
   */
  static readonly GetSubscriptionEventsPath = '/api/Admin/GetSubscriptionEvents/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSubscriptionEvents()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubscriptionEvents$Response(params: {
    id: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<SubscriptionsGetSubscriptionEventsResult>> {

    const rb = new RequestBuilder(this.rootUrl, AdminService.GetSubscriptionEventsPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SubscriptionsGetSubscriptionEventsResult>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getSubscriptionEvents$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubscriptionEvents(params: {
    id: string;
    context?: HttpContext
  }
): Observable<SubscriptionsGetSubscriptionEventsResult> {

    return this.getSubscriptionEvents$Response(params).pipe(
      map((r: StrictHttpResponse<SubscriptionsGetSubscriptionEventsResult>) => r.body as SubscriptionsGetSubscriptionEventsResult)
    );
  }

}
